// External libraries
import gql from 'graphql-tag';
import {
  CART_AMOUNTS_FRAGMENT,
  CART_ITEMS_FRAGMENT,
  CART_OVERCAPTURE_FRAGMENT,
  CART_SUBSCRIPTION_FRAGMENT,
  SHIPPING_METHODS_FRAGMENT,
} from '../fragments';

export const CHECKOUT_SESSION_QUERY = gql`
  query CheckoutSessionQuery($token: String!) {
    checkoutSession(token: $token) {
      cart {
        ...CartAmounts
        ...CartItems
        ...CartOvercapture
        ...ShippingMethods
        ...SubscriptionDetails
      }
    }
  }

  ${CART_AMOUNTS_FRAGMENT}
  ${CART_ITEMS_FRAGMENT}
  ${SHIPPING_METHODS_FRAGMENT}
  ${CART_OVERCAPTURE_FRAGMENT}
  ${CART_SUBSCRIPTION_FRAGMENT}
`;
